var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"island"},[(_vm.header)?_c('h2',[_vm._v(_vm._s(_vm.header))]):_vm._e(),_c('div',{staticClass:"island__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }